module.exports = __webpack_public_path__ + "static/staff-6-4818debef3fe1f898e1faf1672ce8005.png";